// extracted by mini-css-extract-plugin
module.exports = {"broad-compatibility-125w":"BroadCompatibility_broad-compatibility-125w__qt00A"};